/**
 * Report module groupings
 *
 * Single source of truth for the module grid + picker wizard on the
 * Reports page. Maps each module to the real report type ids it owns
 * (from server/modules/reports/report-types.cjs) plus static "coming
 * soon" placeholders for reports not yet built.
 */

export const MODULES = [
  {
    id: 'monitor', name: 'Monitor', icon: 'Monitor', color: '#00d4aa',
    description: 'Device health, uptime, and recording status',
    reportIds: ['SYSTEM_HEALTH', 'RECORDING_ASSURANCE', 'DEVICE_MONITOR_EVENTS'],
    comingSoon: [],
  },
  {
    id: 'access_control', name: 'Access Control', icon: 'DoorOpen', color: '#a78bfa',
    description: 'Door events, cardholders, and access levels',
    reportIds: ['ACCESS_CONTROL', 'ACCESS_CONTROL_USERS', 'EXPIRING_CARDS', 'REGISTRATIONS_BY_DATE'],
    comingSoon: [],
  },
  {
    id: 'ai_integrations', name: 'AI Integrations', icon: 'ScanFace', color: '#ec4899',
    description: 'Facial recognition and analytics',
    reportIds: ['FACIAL_RECOGNITION'],
    comingSoon: [],
  },
  {
    id: 'admin', name: 'Admin', icon: 'Users', color: '#f59e0b',
    description: 'User activity and site-level summaries',
    reportIds: ['USER_ACTIVITY', 'SITE_SUMMARY'],
    comingSoon: [],
  },
  {
    id: 'video', name: 'Video', icon: 'Video', color: '#3b82f6',
    description: 'Camera and VMS event reporting',
    reportIds: [],
    comingSoon: [
      { name: 'Video Events', description: 'Motion and object detection events, single camera or all cameras' },
    ],
  },
];
